import { SettingsHeading } from '../components/settings/SettingsAppearance';
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import MeunSideSetting from "../components/settings/MeunSideSetting";
import PaymentMethod from "./settings/PaymentMethod";
import InvoiceSettings from "./settings/InvoiceSettings";
import GeneralSettings from "./settings/GeneralSettings";
import {
  MwSpinner,
  NoPermission,
  MwButton,
  MwInputText,
} from "../components/ui";
import MwInputFile from "../components/ui/MwInputFile";
import MyCompany from "./settings/MyCompany";
import { useCurrent, useFetch, usePost, usePut } from "../hooks";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setisLogging } from "../store/authSlice";

const Settiings = () => {
  const [activeMenu, setActiveMenu] = useState("GeneralSettings");
  const params = useParams();
  const usernameTenant = params.tenant;
  const [loading, setLoading] = useState(false);
  const [t] = useTranslation("global");
  const { user } = useCurrent();
  const dispatch = useDispatch();
  const location = useLocation();
  const { loading: savingPassword, putData } = usePut();
  const { data: uploadResult, error: uploadError, postData: uploadFile } = usePost(false);
  const [profileName, setProfileName] = useState(user?.name || "");
  const [profileMobile, setProfileMobile] = useState(user?.mobile || "");
  const [profileEmail, setProfileEmail] = useState(user?.email || "");
  const [profileJobTitle, setProfileJobTitle] = useState(user?.jobTitle || "");
  const [profilePic, setProfilePic] = useState(user?.userPic || "");
  const [profileAlert, setProfileAlert] = useState(null);
  const [uploadingPic, setUploadingPic] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [passwordAlert, setPasswordAlert] = useState(null);
  const { data: defineSettingData, loading: defineSettingLoading } = useFetch(
    `${process.env.REACT_APP_Auth_API_BASE_URL}/defineSettings`,
  );

  const filterDefineSetting = (settingName) => {
    return defineSettingData?.data.filter(
      (item) => item.settingName === settingName,
    )[0];
  };

  const refreshTenant = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_Auth_API_BASE_URL}/tenants/username/${usernameTenant}`,
      );
      const _data = res?.data;
      if (_data) {
        localStorage.setItem("tenant", JSON.stringify(_data?.data));
        console.log("refreshTenant", _data?.data);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setProfileName(user?.name || "");
    setProfileMobile(user?.mobile || "");
    setProfileEmail(user?.email || "");
    setProfileJobTitle(user?.jobTitle || "");
    setProfilePic(user?.userPic || "");
  }, [user?.email, user?.jobTitle, user?.mobile, user?.name, user?.userPic]);

  useEffect(() => {
    if (location.state?.tab === "profile") {
      setActiveMenu("MyAccount");
      return;
    }
    if (location.state?.tab === "password") {
      setActiveMenu("ChangePassword");
    }
  }, [location.state]);

  useEffect(() => {
    if (uploadResult?.data?.location) {
      setProfilePic(uploadResult.data.location);
      setUploadingPic(false);
    }
  }, [uploadResult]);

  useEffect(() => {
    if (uploadError) {
      setUploadingPic(false);
      setProfileAlert({ type: "Error", msg: "فشل رفع الصورة" });
    }
  }, [uploadError]);

  const uploadProfilePic = (e) => {
    const file = e?.target?.files?.[0] || null;
    if (!file) return;
    setProfileAlert(null);
    setUploadingPic(true);
    const formData = new FormData();
    formData.append("myfile", file, file.name);
    uploadFile(`${process.env.REACT_APP_UPLOADS_API_BASE_URL}/users`, formData);
  };

  const submitProfileUpdate = async (e) => {
    e.preventDefault();
    setProfileAlert(null);
    const name = String(profileName || "").trim();
    const mobile = String(profileMobile || "").trim();
    const email = String(profileEmail || "").trim();
    if (!name) {
      setProfileAlert({ type: "Error", msg: "الاسم مطلوب" });
      return;
    }
    if (!email) {
      setProfileAlert({ type: "Error", msg: "البريد الإلكتروني مطلوب" });
      return;
    }
    try {
      const result = await putData(`${process.env.REACT_APP_Auth_API_BASE_URL}/users/update`, {
        name,
        mobile,
        email,
        jobTitle: profileJobTitle,
        userPic: profilePic,
      });
      const updatedUser = result?.data?.user || result?.data || result?.user || null;
      if (result?.status === 1 || result?.status === true || updatedUser) {
        const payload = updatedUser || { ...user, name, mobile, email, jobTitle: profileJobTitle, userPic: profilePic };
        localStorage.setItem("user", JSON.stringify(payload));
        localStorage.setItem("userCurrentTs", Date.now().toString());
        dispatch(setisLogging({ user: payload, isLogging: true }));
        setProfileAlert({ type: "Success", msg: "تم تحديث الحساب بنجاح" });
        return;
      }
      setProfileAlert({ type: "Error", msg: result?.message || "فشل تحديث الحساب" });
    } catch (err) {
      setProfileAlert({ type: "Error", msg: err?.response?.data?.message || "فشل تحديث الحساب" });
    }
  };

  const submitChangePassword = async (e) => {
    e.preventDefault();
    setPasswordAlert(null);
    const current = String(currentPassword || "").trim();
    const next = String(newPassword || "").trim();
    const confirm = String(confirmNewPassword || "").trim();
    if (!current || !next || !confirm) {
      setPasswordAlert({ type: "Error", msg: "كل الحقول مطلوبة" });
      return;
    }
    if (next !== confirm) {
      setPasswordAlert({ type: "Error", msg: "كلمة المرور الجديدة وتأكيدها غير متطابقين" });
      return;
    }
    if (next.length < 6) {
      setPasswordAlert({ type: "Error", msg: "كلمة المرور الجديدة قصيرة جداً (6 أحرف على الأقل)" });
      return;
    }
    try {
      const result = await putData(`${process.env.REACT_APP_Auth_API_BASE_URL}/users/change-password`, {
        currentPassword: current,
        newPassword: next,
      });
      if (result?.status === 1) {
        setCurrentPassword("");
        setNewPassword("");
        setConfirmNewPassword("");
        setPasswordAlert({ type: "Success", msg: "تم تحديث كلمة المرور بنجاح" });
        return;
      }
      setPasswordAlert({ type: "Error", msg: result?.message || "فشل تحديث كلمة المرور" });
    } catch (err) {
      setPasswordAlert({ type: "Error", msg: err?.response?.data?.message || "فشل تحديث كلمة المرور" });
    }
  };

  const InlineAlert = ({ alert }) => alert?.msg ? (
    <div className={`mb-3 rounded border px-3 py-2 text-xs ${alert.type === "Error" ? "border-red-200 bg-red-50 text-red-700" : "border-green-200 bg-green-50 text-green-700"}`}>
      {alert.msg}
    </div>
  ) : null;

  return (
    <>
      {/* <h3 className='px-1 pb-1 text-slate-500'>settings</h3>
            <hr className='mb-3'/> */}
    
      <SettingsHeading title={t("setting.System_Settings")} />
      <div className="settings-workspace">
        <MeunSideSetting
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
        />
        {!loading && (
          <div className="settings-content">
            {activeMenu === "MyAccount" && (
              <div className="settings-account-form">
                <div className="text-sm font-semibold text-slate-700 pb-3">حسابي</div>
                <InlineAlert alert={profileAlert} />
                <form onSubmit={submitProfileUpdate} className="flex flex-col gap-3">
                  <div className="flex items-center gap-4">
                    <div className="w-16 h-16 rounded-full overflow-hidden border border-slate-200 bg-white flex items-center justify-center shrink-0">
                      {profilePic ? <img src={profilePic} alt={profileName || "profile"} className="w-full h-full object-cover" /> : <span className="text-slate-500 font-bold">{(profileName || "?").charAt(0)}</span>}
                    </div>
                    <div className="flex-1">
                      <MwInputFile id="profilePic" label="الصورة الشخصية" acceptTypes="image/*" loading={uploadingPic} onChangeHandler={uploadProfilePic} />
                    </div>
                  </div>
                  <MwInputText id="profileName" label="الاسم" value={profileName} onChange={(e) => setProfileName(e.target.value)} classNameInput="text-start" />
                  <MwInputText id="profileJobTitle" label="المسمى الوظيفي" value={profileJobTitle} onChange={(e) => setProfileJobTitle(e.target.value)} classNameInput="text-start" />
                  <MwInputText id="profileMobile" label="الجوال" value={profileMobile} onChange={(e) => setProfileMobile(e.target.value)} classNameInput="text-start" />
                  <MwInputText id="profileEmail" label="البريد الإلكتروني" value={profileEmail} onChange={(e) => setProfileEmail(e.target.value)} classNameInput="text-start" />
                  <div className="pt-2">
                    <MwButton actionType="submit" type="saveBtn" disabled={savingPassword || uploadingPic}>حفظ</MwButton>
                  </div>
                </form>
              </div>
            )}
            {activeMenu === "ChangePassword" && (
              <div className="settings-account-form">
                <div className="text-sm font-semibold text-slate-700 pb-3">تغيير كلمة المرور</div>
                <InlineAlert alert={passwordAlert} />
                <form onSubmit={submitChangePassword} className="flex flex-col gap-3">
                  <MwInputText id="currentPassword" label="كلمة المرور الحالية" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} inputType="password" classNameInput="text-start" />
                  <MwInputText id="newPassword" label="كلمة المرور الجديدة" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} inputType="password" classNameInput="text-start" />
                  <MwInputText id="confirmNewPassword" label="تأكيد كلمة المرور الجديدة" value={confirmNewPassword} onChange={(e) => setConfirmNewPassword(e.target.value)} inputType="password" classNameInput="text-start" />
                  <div className="pt-2 flex items-center gap-2">
                    <MwButton actionType="submit" type="saveBtn" disabled={savingPassword}>حفظ</MwButton>
                    <div className="text-xs text-slate-400">{user?.username ? `المستخدم: ${user.username}` : ""}</div>
                  </div>
                </form>
              </div>
            )}
            {activeMenu === "GeneralSettings" &&
              defineSettingData &&
              !defineSettingLoading && (
                <GeneralSettings
                  filterDefineSetting={filterDefineSetting}
                  refreshTenant={refreshTenant}
                />
              )}
            {activeMenu === "MyCompany" && (
              <MyCompany refreshTenant={refreshTenant} />
            )}
            {activeMenu === "InvoiceSettings" && (
              <InvoiceSettings
                filterDefineSetting={filterDefineSetting}
                refreshTenant={refreshTenant}
              />
            )}
            {activeMenu === "PaymentMethod" && (
              <PaymentMethod
                filterDefineSetting={filterDefineSetting}
                refreshTenant={refreshTenant}
              />
            )}
            {activeMenu !== "MyCompany" &&
              activeMenu !== "MyAccount" &&
              activeMenu !== "ChangePassword" &&
              activeMenu !== "GeneralSettings" &&
              activeMenu !== "InvoiceSettings" &&
              activeMenu !== "PaymentMethod" && (
                <NoPermission msg={`ليس لديك صلاحية للدخول لهذة الصفحة`} />
              )}
          </div>
        )}
        {/* {
                    !loading && (user.user_class_id  )? 
                        <div className='flex-1 bg-slate-50 rounded-lg p-3 '>
                            {activeMenu === 'PaymentMethod' && <PaymentMethod />}
                            {activeMenu === 'InvoiceSettings' && <InvoiceSettings refreshTenant={refreshTenant}/>}
                            {activeMenu === 'GeneralSettings' && <GeneralSettings refreshTenant={refreshTenant}/>}
                            {activeMenu === 'MyCompany' && <MyCompany refreshTenant={refreshTenant}/>}
                        </div>: !user.user_class_id ? <NoPermission msg={`ليس لديك صلاحية للدخول لهذة الصفحة`} /> : <MwSpinner/>
                } */}
      </div>
    </>
  );
};

export default Settiings;
